import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { WebsiteThemeService } from '../../../services/website-theme.service';
import { DomSanitizer } from '@angular/platform-browser';
/**
 * VoucherComponent
 */
let SuccessComponent = class SuccessComponent {
    constructor(sanitizer, themeService) {
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.successColor = '';
        this.inputBackColor = '';
        this.inputTextColor = '';
        this.secondColor = '';
        this.data = '';
        this.address = '';
        this.themeService.getTheme().subscribe((data) => {
            this.successColor = this.themeService.getStyleAttribute('success_color');
            this.inputBackColor = this.themeService.getStyleAttribute('input_background_color');
            this.inputTextColor = this.themeService.getStyleAttribute('input_text_color');
            this.secondColor = this.themeService.getStyleAttribute('secondary_text_color');
        });
        this.data = sessionStorage.getItem('voucherData');
        this.address = sessionStorage.getItem('voucherAddress');
    }
    ngOnInit() {
    }
};
SuccessComponent.ctorParameters = () => [
    { type: DomSanitizer },
    { type: WebsiteThemeService }
];
SuccessComponent = __decorate([
    Component({
        selector: 'ecd-voucher-success',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./success.component.html")).default
    })
], SuccessComponent);
export { SuccessComponent };
